var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Dashboard","icon":"mdi-view-dashboard","class-extra":"mx-auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }